// extracted by mini-css-extract-plugin
export default {"input":"RadioButton_input__p6UCn","inputBox":"RadioButton_inputBox__tpeso"};